<span class="font-600">{{heading}}</span>
<input id="{{id}}" type="text" class="form-control search-input m-t-10" autocomplete="off" placeholder="{{placeholder}}" value="{{value}}">
